export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000"

export const ZERO_BYTES32 = "0x0000000000000000000000000000000000000000000000000000000000000000"

export const MAX_BIG_INT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")